import LoadableGrid from './loadable_grid'
import ReactComponent from 'lib/modulor/react_component'

ReactComponent.register(LoadableGrid, 'Modulor.Grid')
